import FormSectionTitle from '../elements/FormSectionTitle'
import withKeyValue from '../elements/HOC/WithKeyValue'
import withSort from '../elements/HOC/withSort'
import useFetchSelectUrl from '../elements/Hooks/useFetchSelectUrl'
import CustomSelect from '../elements/Select/CustomSelect'
import withSelectFetch from '../elements/Select/withSelectFetch'
import { strVal } from '../modules/Utils'
import React, { Fragment } from 'react'
import { Col, Form, Row, Select } from 'antd'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, rules } from '../modules/FormItems'
import { compose } from 'recompose'

function ProductSelectTree (props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields, doc, title } = props

  const productType = getFieldValue('product.productType') || strVal(doc, 'product.productType')
  const company = getFieldValue('product.company._id') || strVal(doc, 'product.company._id')
  const category = getFieldValue('product.category._id') || strVal(doc, 'product.category._id')
  const group = getFieldValue('product.group._id') || strVal(doc, 'product.group._id')
  const productID = getFieldValue('product.product._id') || strVal(doc, 'product.product._id')

  const categoriesURL = `products/categories/dropdown?type=${productType}&owner=${company}&select=*`
  const groupsURL = `products/groups/dropdown?owner=${company}&category=${category}&select=*`
  const productsUrl = `products/lines?product=${productID}&select=*`
  const productsURL = `products/?owner=${company}&state=Active&category=${category}&group=${group}&select=*`

  const ProductsTypesSelect = compose(
    withSelectFetch({ dropdown: 'products', name: 'type' }),
    withKeyValue(),
    withSort,
  )(CustomSelect)

  const [ProductsLinesSelect] = useFetchSelectUrl(
    {
      name: 'products_lines',
      url: productsUrl,
      forceFetch: true,
    },
    [productsUrl],
    isEmpty(productID),
  )

  const [ProductsSelect] = useFetchSelectUrl(
    {
      name: 'products',
      url: productsURL,
      cache: false,
      forceFetch: true,
    },
    [productsURL],
    false,
    Select,
    ({ name, ...product }) => ({
      name: `${name} - ${strVal(product, 'description')}`,
      ...product,
    }),
  )

  const [CategorySelect] = useFetchSelectUrl(
    {
      name: 'products_categories',
      url: categoriesURL,
      cache: true,
      forceFetch: true,
    },
    [categoriesURL],
    false,
    undefined,
    (c) => c,
    () => resetFields('group._id'),
  )

  const [GroupsSelect] = useFetchSelectUrl(
    {
      name: 'products_groups',
      url: groupsURL,
      cache: true,
      forceFetch: true,
    },
    [groupsURL],
  )

  return (
    <Fragment>
      {title && <FormSectionTitle title={title}/>}

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Type'}>
            {getFieldDecorator('product.productType', {
              initialValue: get(doc, 'product.productType'),
              rules: rules.select,
            })(<ProductsTypesSelect/>)}
          </Form.Item>
        </Col>
        {productType && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Category'}>
              {getFieldDecorator('product.category._id', {
                initialValue: get(doc, 'product.category._id'),
                rules: rules.select,
              })(
                <CategorySelect
                  keyAtr={'_id'}
                  valueAtr={'name'}
                  placeholder={'Category'}
                  // onChange={onChangeProductCategory}
                />,
              )}
            </Form.Item>
          </Col>
        )}
        {category && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Group'}>
              {getFieldDecorator('product.group._id', {
                initialValue: get(doc, 'product.group._id'),
                rules: [{ required: true, message: 'Please Select a Group!' }],
              })(
                <GroupsSelect
                  placeholder={'Group'}
                  keyAtr={'_id'}
                  valueAtr={'name'}
                  // onChange={onChangeProductGroup}
                />,
              )}
            </Form.Item>
          </Col>
        )}

        {group && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Stock Type'}>
              {getFieldDecorator('product.product._id', {
                initialValue: get(doc, 'product.product._id'),
                rules: [
                  {
                    required: true,
                    message: 'Please Select a Stock!',
                  },
                ],
              })(<ProductsSelect placeholder={'Products Type'} keyAtr={'_id'} valueAtr={'name'}/>)}
            </Form.Item>
          </Col>
        )}

        {productID && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Product'}>
              {getFieldDecorator('product.productLine._id', {
                initialValue: get(doc, 'product.productLine._id'),
                rules: rules.select,
              })(
                <ProductsLinesSelect
                  placeholder={'Product'}
                  keyAtr={'_id'}
                  valueAtr={'name'}
                  // onChange={onChangeProductLine}
                />,
              )}
            </Form.Item>
          </Col>
        )}
      </Row>
    </Fragment>
  )
}

export default ProductSelectTree
